import { dealDamage, healDamage, addModifier } from './player.type';
import { getStore, activePlayer, inactivePlayer } from '../../store';
import type { Die } from './die.type';
import { misc } from './techniques/misc';
import { bow } from './techniques/bow';
import { hammer } from './techniques/hammer';
import { sword } from './techniques/sword';
import { axe } from './techniques/axe';
import { stinger } from './techniques/stinger';
import { dagger } from './techniques/dagger';
import { pincer } from './techniques/pincer';
import { claws } from './techniques/claws';
import { horn } from './techniques/horn';
import { beak } from './techniques/beak';
import { bite } from './techniques/bite';
import { basics } from './techniques/basics';
import { shield } from './techniques/shield';
import { shell } from './techniques/shell';
import { fire } from './techniques/fire';
import { lightning } from './techniques/lightning';
import { ice } from './techniques/ice';
import { earth } from './techniques/earth';
import { instant } from './techniques/instant';
import { ammo } from './techniques/ammo';
import { spear } from './techniques/spear';
import { blowgun } from './techniques/blowgun';
import { crossbow } from './techniques/crossbow';
import { note } from './techniques/note';
import { prehensile } from './techniques/prehensile';
// import { mana } from "./techniques/mana";
import type { Player } from './player.type';
import { DieFace } from './face.type';
// From the enum itself, not audio.svelte's re-export -- that one is a `let`
// binding, so it only carries the value meaning and cannot be used as a type.
import type { SoundType } from './sound';

var techniquesIn = [];

export type Requirement = {
  text: string;
  icon?: string;
  iconBonus?: string;
  test: Function;
};
export type Technique = {
  ingredients: Array<DieFace>;
  requirements?: Requirement[];
  title: string;
  text: string;
  activate: Function;
  selected?: Array<Array<Die>>;
  possible?: boolean;
  tags: Array<string>;
  /** Optional: item-granted techniques (potions, consumables, specials) carry no sound. */
  audio?: SoundType | Array<SoundType> | Function;
};

export function filterTechniques(lockedDie: Array<Die>, techniquesIn?: Array<Technique>) {
  var selecteds = lockedDie.filter((die) => die.selected && !die.used);
  var spares = lockedDie.filter((die) => !die.selected && !die.used);
  var used = lockedDie.filter((die) => die.used);

  // var currentTechnique = selecteds.map(selected => selected.faces[selected.value]);

  if (techniquesIn === undefined) {
    techniquesIn = techniques;
  }

  // Finds valid techniques based on selected die
  let validTechniques = getAvailableTechniques([...selecteds, ...spares, ...used], techniquesIn);
  /* if (selecteds.length){
    validTechniques = possibleTechniques(selecteds, [...spares, ...used], validTechniques);
  } */

  return validTechniques;
}

export function validateTechnique(technique: Technique, lockedDie: Array<Die>) {
  var selecteds = lockedDie.filter((die) => die.selected && !die.used);
  var spares = lockedDie.filter((die) => !die.selected && !die.used);
  technique.possible = !!isTechniquePossible(selecteds, spares, technique);

  const dieList = createDieList(selecteds);
  const spareList = createDieList(spares);

  technique.ingredients.forEach((face: DieFace, index: number) => {
    let dice = findDie(dieList, face);
    if (dice.length) {
      const die = dice[0];
      if (technique.selected) {
        technique.selected[index] = [die.die];
      }
      if (die.faces[face]) {
        die.faces[face].count--;
      }
    } else {
      let dice = findDie(spareList, face);
      if (dice.length) {
        const die = dice[0];
        if (technique.selected) {
          // technique.selected[index] = 'found';
        }
        if (die.faces[face]) {
          die.faces[face].count--;
        }
      }
    }
  });
}

export function sortTechniques(techniquesIn: Array<Technique>) {
  return techniquesIn.sort((a, b) => {
    const aPossible = a.possible;
    const bPossible = b.possible;

    if (aPossible && !bPossible) {
      return -1;
    }
    if (!aPossible && bPossible) {
      return 1;
    }

    const x = a.ingredients.join(DieFace.Blank);
    const y = b.ingredients.join('');
    if (x < y) {
      return -1;
    }
    if (x > y) {
      return 1;
    }
    return 0;
  });
}

export function getAvailableTechniques(dice: Array<Die>, techniquesIn?: Array<Technique>) {
  let types: Array<string> = [];
  dice.forEach((die: Die) => {
    die.faces.forEach((face: Array<DieFace>) => {
      /* if (!face || !face.filter){
        console.log(dice, die, face);
      } */
      var asd = face.filter((face) => face !== DieFace.OR);
      asd.forEach((dsa) => {
        if (types.indexOf(dsa) == -1) {
          types.push(dsa);
        }
      });
    });
  });

  const process = techniquesIn || techniques;
  return process.filter((technique) => {
    let keep = technique.ingredients.every((ingredient) => {
      if (types.indexOf(ingredient) !== -1) {
        return true;
      }
    });

    return keep;
  });
}

// filters all techniques to show ones that use the required die
/* export function possibleTechniques(required: Array<Die>, spare: Array<Die>, techniquesIn?: Array<Technique>) {
  const process = techniquesIn || techniques;
  return process.map(technique => {
    const dieList = createDieList(required);
    let keep = false;

    technique.ingredients.forEach((face: DieFace, index: number) => {
      let dice = findDie(dieList, face);
      if (dice.length) {
        const die = dice[0];
        if (die.faces[face]){
          die.faces[face].count --;
        }
        die.used.push(true);
      }

      if (dieList.filter(die => {
        return die.used.length == 0;
      }).length == 0) {
        keep = true;
      }
    });

    technique.hidden = !keep;
    // return keep;
    return technique;
  });
} */

function createDieList(die: Array<Die>): Array<DieListItem> {
  return die.map((die) => {
    // if the die is an OR die, shares a counter object
    if (die.value().indexOf(DieFace.OR) !== -1) {
      const counter = {
        count: 1,
      };
      let obj: Partial<Record<DieFace, { count: number }>> = {};
      for (let face of die.value().filter((face) => face !== DieFace.OR)) {
        obj[face] = counter;
      }

      return {
        die: die,
        faces: obj,
        used: [],
      };
    }

    // if the die is an AND die or single face die, has a counter object for each face
    let obj: Partial<Record<DieFace, { count: number }>> = {};
    for (let face of die.value()) {
      if (obj[face]) {
        obj[face].count++;
      } else {
        obj[face] = { count: 1 };
      }
    }
    return {
      die: die,
      faces: obj, // object that contains the count of each face type on the die
      used: [],
    };
  });
}

type DieListItem = {
  die: Die;
  faces: Partial<Record<any, { count: number }>>;
  used: Array<boolean>;
};

function findDie(dieList: Array<DieListItem>, key: DieFace): Array<DieListItem> {
  if (key === DieFace.Blank) {
    return dieList
      .sort((a, b) => {
        // if value exactly matches die, sort it first
        if (a.die.value()[0] == key) {
          return -1;
        }
        if (b.die.value()[0] == key) {
          return 1;
        }
        return 0;
      })
      .map((die) => {
        for (let keyy of Object.keys(die.faces)) {
          die.faces[key] = { count: die.die.value()[0] === '' ? 1 : 0 };
          if (die.faces[keyy] && die.faces[keyy].count > die.faces[key].count) {
            die.faces[key] = die.faces[keyy];
          }
        }
        return die;
      })
      .filter((die) => {
        if (die.faces[DieFace.Broken]) {
          return false;
        }
        //iterate through die.faces array to find the total count value
        return Object.keys(die.faces).reduce((total, face) => {
          if (die.faces[face]) {
            return total + die.faces[face].count;
          }
          return total;
        }, 0);
      });
  }

  return dieList
    .filter((die) => {
      return (
        (die.faces[key] && die.faces[key].count > 0) ||
        (die.faces[DieFace.Wildcard] && die.faces[DieFace.Wildcard].count > 0)
      );
    })
    .map((die) => {
      if (die.faces[DieFace.Wildcard] && !die.faces[key]) {
        die.faces[key] = die.faces[DieFace.Wildcard];
      }
      return die;
    });
}

export function isTechniquePossible(required: Array<Die>, spare: Array<Die>, technique: Technique) {
  // Convert ingredients to a dictionary
  const dieList = createDieList(required);
  const spareList = createDieList(spare);

  // Helper function to recursively generate all possible combinations of the recipe
  function checkCombination(index: number) {
    if (index === technique.ingredients.length) {
      return true; // All elements of the technique have been assigned a value
    }

    const key = technique.ingredients[index];
    // required die
    let dice = findDie(dieList, key as DieFace);
    // spare die if required there is not a matching required
    if (!dice.length) {
      dice = findDie(spareList, key as DieFace);
    }

    for (const die of dice) {
      if (die.faces[key]) {
        die.faces[key].count--;
        die.used.push(true);
        if (checkCombination(index + 1)) {
          return true;
        }
        die.faces[key].count++;
        die.used.pop();
      }
    }

    return false;
  }

  // Start recursion from index 0
  var result = checkCombination(0);

  // makes sure all required die are used at least once
  if (
    dieList.filter((die) => {
      return die.used.length == 0;
    }).length > 0
  ) {
    return false;
  }

  if (result) {
    // converts result into a list of the used die
    const passed = dieList
      .map((die) => {
        return die.die;
      })
      .concat(
        spareList
          .filter((die) => {
            return die.used.length > 0;
          })
          .map((die) => {
            return die.die;
          }),
      );

    if (!passed.length && technique.ingredients.length > 0) {
      return false;
    }

    // checks if the technique has any requirements
    let test = true;
    if (technique.requirements) {
      for (let requirement of technique.requirements) {
        if (!requirement.test(getStore(activePlayer), getStore(inactivePlayer))) {
          test = false;
        }
      }
    }
    if (!test) {
      return false;
    }

    return passed;
  }

  return false;
}

export function filterTechniquesByTag(tag: string) {
  return techniques.filter((technique) => {
    return technique.tags.includes(tag);
  });
}

// function that returns the positions of the die in the technique's ingredient list
export function fitDieInTechnique(die: Die, technique: Technique) {
  if (!technique.ingredients || technique.ingredients.length === 0) {
    return false;
  }

  const dieList = createDieList([die]);

  const positions: Array<number> = [];
  technique.ingredients.forEach((ingredient: DieFace, index: number) => {
    if (ingredient === DieFace.OR) {
      return;
    }

    if (!technique.selected) {
      technique.selected = [];
    }

    if (technique.selected[index] && technique.selected[index].length) {
      return;
    }

    const dice = findDie(dieList, ingredient);
    if (dice.length) {
      const dieItem = dice[0];
      if (dieItem.faces[ingredient] && dieItem.faces[ingredient].count > 0) {
        dieItem.faces[ingredient].count--;
        positions.push(index);
      }
    }
  });

  if (positions.length === 0) {
    return false;
  }

  return positions;
}

export const techniques: Technique[] = misc
  .concat(bow)
  .concat(hammer)
  .concat(sword)
  .concat(axe)
  .concat(stinger)
  .concat(dagger)
  .concat(shell)
  .concat(pincer)
  .concat(claws)
  .concat(horn)
  .concat(beak)
  .concat(bite)
  .concat(basics)
  .concat(shield)
  .concat(fire)
  .concat(ice)
  .concat(lightning)
  .concat(earth)
  .concat(instant)
  .concat(ammo)
  .concat(spear) /* .concat(mana) */
  .concat(blowgun)
  .concat(crossbow)
  .concat(note)
  .concat(prehensile);

techniques
  .map((technique) => {
    technique.selected = [];
    return technique;
  })
  .sort((a, b) => {
    const x = a.ingredients.join(DieFace.Blank);
    const y = b.ingredients.join('');
    if (x < y) {
      return -1;
    }
    if (x > y) {
      return 1;
    }
    return 0;
  });

const parseTechniques = () => {
  const titles: Array<string> = [];
  techniques.forEach((technique) => {
    //check for duplicate technique titles
    if (titles.includes(technique.title)) {
      console.error('Duplicate technique title: ' + technique.title, technique);
    }
    titles.push(technique.title);
  });
};
parseTechniques();
